import axios from "axios";
import { API_BASE_URL } from "../constants/api";
import { extractErrorMessage } from "@/utils/api";
import { message } from "antd";

export const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    config.withCredentials = true;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let isRedirecting = false;

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401 && !isRedirecting) {
      isRedirecting = true;

      localStorage.removeItem("user");

      if (window.location.pathname !== "/login") {
        const event = new CustomEvent("auth:unauthorized", {
          detail: { error },
        });

        window.dispatchEvent(event);

        setTimeout(() => {
          window.location.href = "/login";
        }, 100);
      }

      setTimeout(() => {
        isRedirecting = false;
      }, 2000);
    }

    message.error(extractErrorMessage(error) || "An unexpected error occurred");
    return Promise.reject(error);
  }
);
